// Shared config for the storefront page-analytics trackers.
// Events are sent to the Medusa backend's /store endpoints.

export const PA_BACKEND_URL =
  process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL || "http://localhost:9000"

export const PA_PUBLISHABLE_KEY =
  process.env.NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY || ""

// Namespaces events in case the same backend ever serves multiple frontends.
export const PA_PROJECT_ID = "storefront"

export const PA_EVENTS_ENDPOINT = `${PA_BACKEND_URL}/store/page-analytics/events`
export const PA_PAGE_VIEWS_ENDPOINT = `${PA_BACKEND_URL}/store/page-analytics/page-views`

// Sent on every request so Medusa's publishable-key store middleware is
// satisfied even though sendBeacon is disabled.
export const PA_HEADERS: Record<string, string> = PA_PUBLISHABLE_KEY
  ? { "x-publishable-api-key": PA_PUBLISHABLE_KEY }
  : {}
